import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vacancies_regions" }
const _hoisted_2 = { class: "flex itemscenter justify-between" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_categories_actions = _resolveComponent("categories-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_categories_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCreate: _ctx.createCategory,
          onUpdate: _ctx.updateCategory,
          onDelete: _ctx.deleteCategory,
          onCancel: _ctx.closeModal
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate", "onDelete", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Категории автомобилей" }),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить категорию ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.state.is_failed && !_ctx.data_state.vehicle_types.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.is_loading,
              text: "При получении списка категорий произошла ошибка",
              "error-message": _ctx.data_state.vehicle_types.failure.error_state.message,
              "error-url": _ctx.data_state.vehicle_types.failure.error_state.url,
              "error-status": _ctx.data_state.vehicle_types.failure.error_state.status,
              onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadVehicleTypes(_ctx.data_state.vehicle_types.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.is_loading,
                  columns: _ctx.CouriersCategoriesColumns,
                  rows: _ctx.data_state.vehicle_types.list,
                  pagination: "",
                  "pagination-current-page": _ctx.data_state.vehicle_types.pagination.current_page,
                  "pagination-limit": _ctx.data_state.vehicle_types.pagination.limit,
                  "pagination-total-items": _ctx.data_state.vehicle_types.pagination.total_items,
                  "pagination-total-pages": _ctx.data_state.vehicle_types.pagination.total_pages,
                  onChangePage: _ctx.loadVehicleTypes
                }, {
                  actions: _withCtx(({ row }) => [
                    _createVNode(_component_the_button, {
                      class: "yellow extra-small",
                      onClick: ($event: any) => (_ctx.startUpdate(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_the_button, {
                      class: "red extra-small ml-3",
                      onClick: ($event: any) => (_ctx.startDelete(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}